module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4215c0114ad52c7983f5192673e0dbff.png";